<template>
    <Loading :loading="loading" :inset="true" class="my-4">
        <SectionWrapper borderPosition="bottom" id="account">
            <template #title>
                {{ $t('contact_information') }}
            </template>
            <template #content>
                {{ salutation }} {{ user?.first_name }} {{ user?.last_name }}<br />
                {{ $t('mail') }}: {{ user?.email }}<br />
                {{ $t('acount_birthday') }}: {{ birthday_readable }}<br />
                {{ $t('profile_phone') }}: {{ customer.phone ? customer.phone : '—' }}<br />
                {{ $t('profile_mobile') }}: {{ customer.mobile ? customer.mobile : '—' }}<br />
            </template>
        </SectionWrapper>

        <SectionWrapper borderPosition="bottom" id="address">
            <template #title>
                {{ $t('profile_adress') }}
            </template>
            <template #content>
                {{ customer.street }}<br />
                {{ customer.zipcode }}, {{ customer.location }}<br />
                {{ $translate(customer.country?.name) }}<br />
            </template>
        </SectionWrapper>

        <SectionWrapper borderPosition="bottom" id="company" v-if="customer.type === 'business'">
            <template #title>
                {{ $t('plain_company') }}
            </template>
            <template #content>
                {{ $t('company_name') }}: {{ customer.company }}<br />
                {{ $t('tax_number') }}: {{ customer.tax_number }}<br />
                {{ $t('email_invoice') }}: {{ customer.email_invoice }}<br />
            </template>
        </SectionWrapper>

        <FormButton @click="$emit('edit')" class="text-blue" :value="$t('plain_edit')" />
        <p v-if="checkoutAccountDataError" class="mt-2 text-red text-xs">
            {{ $t('complete_customer_data') }}
        </p>
        <hr class="my-8 w-full border-b-0.5 border-gray-300" />
    </Loading>
</template>

<script>
import { mapGetters } from 'vuex';
import i18next from 'i18next';
import { formatDateByRegion } from '../../helpers.js';

export default {
    props: ['submitButton', 'successMessage', 'showChangePassword', 'checkoutAccountDataError'],

    data: () => ({
        loading: true
    }),

    methods: {
        i18next() {
            return i18next;
        }
    },

    mounted() {
        let promises = [];
        this.$store.dispatch('user/user').then(() => {
            // get customer data if user has customer.id
            if (this.user?.customer_id) {
                promises.push(this.$store.dispatch('customers/show', this.user.customer_id));
            }

            Promise.all(promises).then((values) => {
                this.loading = false;
            });
        });
    },

    computed: {
        ...mapGetters('user', {
            user: 'get'
        }),
        ...mapGetters('customers', {
            customer: 'get'
        }),
        birthday_readable() {
            if (!this.user?.birthday_at) return '—';

            return formatDateByRegion(this.$moment(this.user.birthday_at));
        },
        language() {
            return window.meta.region_configuration.region;
        },
        salutation() {
            if (this.user?.salutation === 'male' || this.user?.salutation === 'female') {
                return i18next.t('profile_salutation_' + this.user.salutation);
            }
            return '';
        }
    }
};
</script>
